export default {
  'Add Employee': 'Add Employee',
  'Edit Employee': 'Edit Employee',
  'Employee List': 'Employee List',
  'Basic info': 'Basic info',
  Position: 'Position',
  Save: 'Save',
  Mobile: 'Mobile',
  //Please upload your profile picture
  'Email or Mobile': "Email or Mobile",
  'Please enter your name': 'Please enter your name',
  'Please enter your mobile': 'Please enter your mobile',
  'Mobile already exist': 'Mobile already exist',
  'Mobile is not correct': 'Please enter the correct mobile number',
  'Please enter your email': 'Please enter your email',
  'Please enter your email correctly': 'Please enter the correct email',
  'Email already exist': 'The account already exists, please return to login.If you forgot your password, please click "Forgot password" to reset',
  Confirm: 'Reminder',
  'Are you sure detele this item?': 'Confirm to detele the item？',
  'Are you sure detele this item1?': 'Your operation will delete all currently selected exhibits. Do you want to continue?',
  'Are you sure detele this item2?': 'Confirm to detele the item？',
  'Please enter your mobile or email': 'Please enter your mobile or emai',
  'Mobile number or Email are not correct': 'Please enter the correct mobile number and email'
}
